var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { align: "baseline", dense: _vm.dense } },
    [
      _vm._t("label", function () {
        return [
          _vm.label
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: _vm.labelSize } },
                [
                  _c(
                    "v-card",
                    { staticClass: "d-flex", attrs: { flat: "" } },
                    [
                      _c("v-card", { attrs: { flat: "" } }, [
                        _c("span", { staticClass: "text-subtitle-1" }, [
                          _vm._v(_vm._s(_vm.label)),
                        ]),
                        _vm.hint
                          ? _c("div", [
                              _c("span", { staticClass: "text-caption" }, [
                                _vm._v(_vm._s(_vm.hint)),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
      _c(
        "v-col",
        { staticClass: "grow" },
        [
          _c("v-combobox", {
            attrs: {
              items: _vm.items,
              chips: "",
              multiple: _vm.multiple,
              delimiters: [","],
              "item-text": "text",
              "return-object": "",
              dense: _vm.dense,
            },
            scopedSlots: _vm._u([
              {
                key: "selection",
                fn: function (data) {
                  return [
                    _c(
                      "v-chip",
                      _vm._b(
                        {
                          key: JSON.stringify(data.item),
                          attrs: {
                            "input-value": data.selected,
                            disabled: data.disabled,
                            close: _vm.multiple,
                            color: data.item.color,
                            small: _vm.dense,
                            dense: _vm.dense,
                          },
                          on: {
                            "click:close": function ($event) {
                              return data.parent.selectItem(data.item)
                            },
                          },
                        },
                        "v-chip",
                        data.attrs,
                        false
                      ),
                      [_vm._v(" " + _vm._s(data.item.text) + " ")]
                    ),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.computedValue,
              callback: function ($$v) {
                _vm.computedValue = $$v
              },
              expression: "computedValue",
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }